

































































































import { Component, Watch } from 'vue-property-decorator';
import { Getter, Action, Mutation } from 'vuex-class';
import { SelectWings, ScrollButton } from "wings-ui-components";
import ApplicationAttributesFilter from '@/components/Push/Attributes/ApplicationAttributesFilter.vue';
import BaseItemsPage from '../BaseItemsPage';
import { ApplicationAttributeItem } from '@/store/push/attributes/types';


@Component({components:{ApplicationAttributesFilter, ScrollButton, SelectWings}})
export default class ApplicationAttributes extends BaseItemsPage<ApplicationAttributeItem> {
  @Getter("applicationAttributes") applicationAttributesResponse: any;
  @Getter("pushApplications") pushApplicationsList: any;
  @Action("getPushApplications") actionGetPushApplications: any;
  @Mutation("setApplicationAttributes") setApplicationAttributes: any;
  private is_show_filter = false;
  private applicationId?: number = 0;
  currentSort= "id";
  currentSortOrder= "desc";
  tableFields = [
    'id',
    'name',
    'type',
    'owner',
  ];

  created() {
    const applicationId = localStorage.getItem('application_id_attributes');
    this.applicationId = applicationId !== null ? parseInt(applicationId) : undefined;
    this.actionGetPushApplications();
  }

  getData(): any {
    return this.applicationAttributesResponse;
  }

  @Watch('applicationId')
  onApplicationId(val?:number, oldVal?:number){
    if (val) {
      localStorage.setItem('application_id_attributes', val.toString());
    } else {
      localStorage.removeItem('application_id_attributes');
      this.setApplicationAttributes([])
    }
  }
}
